export const ACTIVE_TOUR_KEY = 'tk_active_tour';
export const PENDING_TOUR_KEY = 'tk_pending_tour';

export function readActiveTour() {
  try {
    const raw = sessionStorage.getItem(ACTIVE_TOUR_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.id || typeof parsed.step !== 'number') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeActiveTour(state) {
  try {
    if (!state) {
      sessionStorage.removeItem(ACTIVE_TOUR_KEY);
      return;
    }
    sessionStorage.setItem(ACTIVE_TOUR_KEY, JSON.stringify(state));
  } catch {
    /* private mode */
  }
}

export function readPendingTour() {
  try {
    return sessionStorage.getItem(PENDING_TOUR_KEY) || '';
  } catch {
    return '';
  }
}

export function writePendingTour(tourId) {
  try {
    if (!tourId) sessionStorage.removeItem(PENDING_TOUR_KEY);
    else sessionStorage.setItem(PENDING_TOUR_KEY, tourId);
  } catch {
    /* private mode */
  }
}

export function loginPathForTour(tourId) {
  return `/login?signup=true`;
}

export function rememberLoginThenTour(tourId) {
  writePendingTour(tourId);
  try {
    sessionStorage.setItem('login_redirect', '/dashboard');
  } catch {
    /* private mode */
  }
}
